//HomePage = Hero Section
 document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.hero-block-slider', {
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        spaceBetween: 0,
    });
  });


//HomePage = Tab collection Section
document.addEventListener('DOMContentLoaded', () => {
  const tabBlockTitles = document.querySelectorAll(".collection-tab-blocks .tab-block");
  const tabContentBlocks = document.querySelectorAll(".tab_content-block .collection-tab_content");
  tabBlockTitles.forEach(tabTitle => {
    tabTitle.addEventListener('click', () => {
      const currentTab = tabTitle.getAttribute('data-tab');  
      tabBlockTitles.forEach(title => title.classList.toggle('active', title === tabTitle));
      tabContentBlocks.forEach(contentBlock => {
        contentBlock.classList.toggle('active', contentBlock.getAttribute('data-tab') === currentTab);
      });
    });
  });
});


// custom featured collection swiper
$(document).ready(function(){
  const swiper = new Swiper(".cst-collection-products", {
    direction: "horizontal",
    slidesPerView: 4,
    spaceBetween: 25,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 35,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 30,
      }
    } 
  }); 
});


// thumbanil slider product page
$(document).ready(function(){
  $('.main-product-item').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    asNavFor: '.product__submedia-list',
    //focusOnSelect: true
  });
  var $thumbnailSlider = $(".product__submedia-list").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    dots: false,
    // infinite: false,
    focusOnSelect: true,
    centerMode: true,
    centerPadding: '0px',
    asNavFor: '.main-product-item'
  });
  $thumbnailSlider.on('afterChange', function(event, slick, currentSlide){
    var totalSlides = slick.$slides.length;
    if(currentSlide === 0){
      $('.slick-prev').hide();
    } else {
      $('.slick-prev').show();
    }
    if(currentSlide === totalSlides - 1){
      $('.slick-next').hide();
    } else {
      $('.slick-next').show();
    }
  });
  $thumbnailSlider.slick('slickGoTo', 0, true);
});


// footer accordian js
$(document).ready(function() {
  function handleFooterAccordion() {
    const $headings = $('.footer-block--menu .footer-block__heading');
    const isSmallScreen = $(window).width() < 576;
    if (isSmallScreen) {
      $headings.off('click').on('click', function() {
        const $currentHeading = $(this);
        const $currentContent = $currentHeading.siblings();
        $headings.not($currentHeading).each(function() {
          const $otherContent = $(this).siblings();
          if ($otherContent.is(':visible')) {
            $otherContent.slideUp();
            $(this).removeClass('active');
          }
        });
        $currentContent.slideToggle();
        $currentHeading.toggleClass('active');
      }).siblings().hide();
    } else {
      $headings.off('click').removeClass('active');
      $headings.siblings().show().removeAttr('style');
    }
  }
  handleFooterAccordion();
  $(window).resize(handleFooterAccordion);
});

// faq accordian js
$(document).ready(function() {
  function faqAccordion() {
    let $accoHeadings = $('.faq-accordian .acc-block-wrap .acco-head');
    console.log("$accoHeadings :: ",$accoHeadings);
    $accoHeadings.off('click').on('click', function() {
      let $selectHeading = $(this);
      let $selectedContent = $selectHeading.next();

      $accoHeadings.not($selectHeading).each(function() {
        let $otherContent = $(this).next(); 
        if ($otherContent.is(':visible')) {
          $otherContent.slideUp();
          $(this).removeClass('active');
        }
      });
      $selectedContent.slideToggle();
      $selectHeading.toggleClass('active');
    });
  }
  faqAccordion();
  $(window).resize(function() {
  });
});


//Accordian Section js ( product page )
$(document).ready(function() {
  function accordion() {
    let $accoHeadings = $('.product__info-container .acc-block-wrap .acco-head');

    $accoHeadings.off('click').on('click', function() {
      let $selectHeading = $(this);
      let $selectedContent = $selectHeading.next();

      $accoHeadings.not($selectHeading).each(function() {
        let $otherContent = $(this).next(); 
        if ($otherContent.is(':visible')) {
          $otherContent.slideUp();
          $(this).removeClass('active');
        }
      });
      $selectedContent.slideToggle();
      $selectHeading.toggleClass('active');
    });
    $('.product__info-container .acc-block-wrap .acco-head').next().hide();
  }
  accordion();
  $(window).resize(function() {
  });
});



// Function to set the top property of the image-wrapper
function adjustImageWrapperTop() {
    const stickyHeader = document.querySelector('sticky-header');
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    const imageWrapper = document.querySelector('.sticky-image-with-text .image-block .image-wrapper');
    
    if (imageWrapper) {
        imageWrapper.style.top = `${headerHeight}px`;
    }
}
adjustImageWrapperTop();
window.addEventListener('resize', adjustImageWrapperTop);




// For Account page
$(function() {
  $('a.my-order-block').click(function(event) {
    const stickyHeader = document.querySelector('sticky-header');
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    const height = headerHeight;
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - height
    }, 1000);
  });
});



$(function() {
  $('a.account-info').click(function(event) {
    const cst_Header = document.querySelector('sticky-header');
    const cst_headerHeight = cst_Header ? cst_Header.offsetHeight : 0;
    const cst_height = cst_headerHeight;
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - cst_height
    }, 1000);
  });
});



// popup newletter
/* 
$(document).ready(function() {
  // Check if the popup has been shown before
  if (!localStorage.getItem('popupShown')) {
    $('body').addClass('overflow-hidden');
    $('.offer-pop-up-wrapper').addClass('open-popup');

    // Set the popup as shown in local storage
    localStorage.setItem('popupShown', 'true');
  }

  // Handle the close button click
  $(document).on('click', '.close-icon-wrap', function(e) {
    e.preventDefault();
    $('.offer-pop-up-wrapper').removeClass('open-popup');
    $('body').removeClass('overflow-hidden');
  });

  // Click outside to close popup
  $('body').on('click', function(e) {
    if ($(e.target).closest('.offer-pop-up-wrapper.open-popup').length && !$(e.target).closest('.offer-pop-up-wrapper .footer-block__details-content').length) {
      $('.offer-pop-up-wrapper').removeClass('open-popup');
      $('body').removeClass('overflow-hidden');
    }
  });

  // Handle form submission
  $('#ContactFooter').on('submit', function(e) {
    e.preventDefault(); // Prevent the default form submission
    setTimeout(function() {
      $('.offer-pop-up-wrapper').removeClass('open-popup');
      $('body').removeClass('overflow-hidden');
    }, 3000); 
  });
}); */



AOS.init();








